// extracted by mini-css-extract-plugin
export default {"log_reg_form":"Access_log_reg_form__SHigd","error_message":"Access_error_message__qRlAo"};